
// lightbox.js

(() => {
    "use strict";

    const lightbox = document.getElementById('gallery-lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const closeBtn = document.getElementById('lightbox-close');
    const prevBtn = document.getElementById('lightbox-prev');
    const nextBtn = document.getElementById('lightbox-next');

    if (!lightbox || !lightboxImg || !closeBtn || !prevBtn || !nextBtn) return;

    // Track state variables across clicks
    let currentTriggers = [];
    let currentIndex = -1;

    // Helper function to update the visible lightbox details cleanly
    const updateLightboxContent = (index) => {
        if (index < 0 || index >= currentTriggers.length) return;
        
        currentIndex = index;
        const targetTrigger = currentTriggers[currentIndex];
        const targetImg = targetTrigger.querySelector('img');

        if (targetTrigger && targetImg) {
            lightboxImg.src = targetTrigger.getAttribute('data-fullsrc');
            lightboxImg.alt = targetImg.alt;
        }
    };

    // 1. Delegate global clicks targeting gallery thumbnails
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.gallery-trigger');
        if (!trigger) return;

        // Collect all related pictures in this grid right at click time
        const parentGrid = trigger.closest('.gallery-grid');
        currentTriggers = parentGrid ? Array.from(parentGrid.querySelectorAll('.gallery-trigger')) : [trigger];
        
        // Find where our clicked item sits inside the array sequence
        const foundIndex = currentTriggers.indexOf(trigger);

        updateLightboxContent(foundIndex);
        lightbox.showPopover();
    });

    // 2. Control Trigger Listeners: Step Backward
    prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        // Calculate previous index, looping around to the end if at the start
        const newIndex = (currentIndex - 1 + currentTriggers.length) % currentTriggers.length;
        updateLightboxContent(newIndex);
    });

    // 3. Control Trigger Listeners: Step Forward
    nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        // Calculate next index, looping back to the front if at the end
        const newIndex = (currentIndex + 1) % currentTriggers.length;
        updateLightboxContent(newIndex);
    });

    // 4. Explicit native close layout binding
    closeBtn.addEventListener('click', () => {
        lightbox.hidePopover();
    });
})();